import {allUsersURL, currentUserURL} from "../../services/api";
import {
    FETCH_USER,
    FETCH_USER_FAIL,
    FETCH_USERS,
    SET_FAIL_MESSAGE_USER,
    FETCH_USERS_FAIL,
    FETCH_CURRENT_USER,
    EDIT_CURRENT_USER,
    EDIT_CURRENT_USER_FAIL,
    FETCH_CURRENT_USER_FAIL,
    DELETE_CURRENT_USER_FAIL,
    POST_USER,
    POST_USER_FAIL,
    EDIT_USER,
    EDIT_USER_FAIL,
    DELETE_USER,
    LOADING_USERS, CURRENT_USER_IS_LOADING
} from "./userTypes";
import {oneUserURL} from "../../services/api";
import api from '../../services/instanceapi'
import {checkErrorMessage} from "../../utils/utils";

export const loadUsers = () => async (dispatch) => {
    dispatch({
        type: LOADING_USERS,
    });
    try {
        const users = await api.get(allUsersURL());
        dispatch({
            type: FETCH_USERS,
            payload: {
                users: users.data,
                status: 200,
                message: "OK"
            }
        });
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: FETCH_USERS_FAIL,
                payload: {
                    message: message,
                    status: status
                },
            });
        }
    }
}


export const loadUser = (id) => async (dispatch) => {
    try {
        const user = await api.get(oneUserURL(id))
        dispatch({
            type: FETCH_USER,
            payload: {
                id: user.data.id,
                firstName: user.data.firstName,
                lastName: user.data.lastName,
                phone: user.data.phone,
                photo: user.data.photo,
                email: user.data.email,
                roles: user.data.roles,
                tags: user.data.tags,
                projects: user.data.projects,
                status: 200,
                message: "OK"
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: FETCH_USER_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE_USER,
                payload: {
                    message: message
                },
            });
        }
    }
}

export const postUser = (data) => async (dispatch) => {
    try {
        const user = await api.post(allUsersURL(), data)
        dispatch({
            type: POST_USER,
            payload: {
                status: user.status
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: POST_USER_FAIL,
                payload: {
                    status: e.response.status,
                    message: message
                },
            });
        }
    }
}


export const deleteOneUser = (id) => async (dispatch) => {
    try {
        await api.delete(oneUserURL(id))
        dispatch({
            type: DELETE_USER,
        });
    } catch (e) {
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: DELETE_CURRENT_USER_FAIL,
            });

        }
    }
}
export const loadCurrentUser = () => async (dispatch) => {
    dispatch({
        type: CURRENT_USER_IS_LOADING
    })
    try {
        const user = await api.get(currentUserURL())
        dispatch({
            type: FETCH_CURRENT_USER,
            payload: {
                id: user.data.id,
                firstName: user.data.firstName,
                lastName: user.data.lastName,
                tags: user.data.tags,
                roles: user.data.roles,
                phone: user.data.phone,
                photo: user.data.photo,
                email: user.data.email,
                projects: user.data.projects,
                isPilot: user.data.isPilot,
                isCopilot: user.data.isCopilot,
                message: "OK",
                status: 200,
            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        dispatch({
            type: FETCH_CURRENT_USER_FAIL,
        });
        dispatch({
            type: SET_FAIL_MESSAGE_USER,
            payload: {
                message: message
            },
        });

    }
}

export const editCurrentUser = (id, data) => async (dispatch) => {
    try {
        const currentUser = await api.patch(oneUserURL(id), data)
        dispatch({
            type: EDIT_CURRENT_USER,
            payload: {
                id: currentUser.data.id,
                firstName: currentUser.data.firstName,
                lastName: currentUser.data.lastName,
                tags: currentUser.data.tags,
                phone: currentUser.data.phone,
                photo: currentUser.data.photo,
                email: currentUser.data.email,
                projects: currentUser.data.projects,
                roles: currentUser.data.roles,

            }
        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: EDIT_CURRENT_USER_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE_USER,
                payload: {
                    message: message
                },
            });
        }
    }
}

export const editUser = (id, data) => async (dispatch) => {
    try {
        const user = await api.patch(oneUserURL(id), data)
        dispatch({
            type: EDIT_USER,
            payload: {
                id: user.data.id,
                firstName: user.data.firstName,
                lastName: user.data.lastName,
                phone: user.data.phone,
                photo: user.data.photo,
                email: user.data.email,
                projects: user.data.projects,
                roles: user.data.roles,
                status: 200,
            }
        })
    } catch (e) {
        const status = e?.response?.status
        if (status !== 200) {
            dispatch({
                type: EDIT_USER_FAIL,
                payload: {
                    status: status
                },
            });
        }
    }
}

